
import React from 'react';

const EcoFriendlySection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">🌱 Eco-Friendly & Solar-Ready Roofing</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="text-left">
              <h3 className="text-xl font-semibold mb-4">Energy-Efficient Solutions</h3>
              <ul className="space-y-2">
                <li>• <a href="https://www.energystar.gov/products/building_products/roof_products" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">ENERGY STAR®</a> shingles: Atlas® & Owens Corning Cool Series®</li>
                <li>• Solar prep: racking, decking reinforcement, and roof-penetration sealing</li>
                <li>• Radiant barrier underlayment & attic venting upgrades</li>
              </ul>
            </div>
            <div className="text-left">
              <h3 className="text-xl font-semibold mb-4">Performance Benefits</h3>
              <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                <p className="text-sm">
                  Roof coating systems that reduce heat absorption by 40% (<a href="https://coolroofs.org" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Cool Roof Rating Council</a>)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EcoFriendlySection;
